// extracted by mini-css-extract-plugin
export var profileImageBase = "layout-module--profileImageBase--32b88";
export var profileImageDarkMode = "layout-module--profileImageDarkMode--53867";
export var profileImageLightMode = "layout-module--profileImageLightMode--cd5a8";